import React from 'react';

import type { Page } from 'types/page';

import Image from 'next/image';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import Figure from './figure';

const HeroConditions: React.FC<
  Pick<Page['acf']['hero'], 'title' | 'subTitle' | 'image'>
> = ({ title, subTitle, image }) => (
  <Wrap
    tagName="header"
    className="grid md:grid-cols-2 md:gap-x-10 lg:gap-x-20 pb-0 sm:pb-10 xl:py-0"
  >
    <div>
      <HeadingBody className="pb-10" title={title} level="4" tagName="h1" />
      <HeadingBody title={subTitle} level="2" />
    </div>
    <Figure {...image} priority className="w-full bg-transparent" />
    <figure className="hidden absolute -z-1 w-1/2 md:block top-0 right-0 opacity-80">
      <Image
        src="/bg-purple-green-gradient.jpg"
        width={1515}
        height={1280}
        alt=""
      />
    </figure>
  </Wrap>
);

export default HeroConditions;
